import {Map} from 'immutable'
import React from 'react'
import {connect} from 'react-redux'

import {
  SESSION_REQUEST_STATUSES,
  SESSION_STATUSES,
  PAY_AS_YOU_GO_VALUE
} from './config/constants'

import acceptSessionRequest from './data/setters/accept_session_request'
import dismissSessionRequest from './data/setters/dismiss_session_request'
import closeModal from './data/actions/close_modal'

import ModalView from './modal_view'
import GoToSessionButton from './go_to_session_button'

class SessionRequestModal extends React.Component {
  constructor (props) {
    super(props)

    this.acceptRequest = this.acceptRequest.bind(this)
    this.dismissRequest = this.dismissRequest.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    const {sessionRequest} = this.props
    const {sessionRequest: nextSessionRequest} = nextProps

    if (sessionRequest && !nextSessionRequest) {
      this.closeModal()
    }
  }

  isSessionGoodToGo (status, length) {
    const {BOOKED, COMPLETED} = SESSION_STATUSES

    if (status === BOOKED && length === PAY_AS_YOU_GO_VALUE) return true
    if (status > BOOKED && status < COMPLETED) return true

    return false
  }

  acceptRequest (e) {
    if (e) e.preventDefault()

    this.props.onAcceptRequest(
      this.props.sessionRequest.get('expert'),
      this.props.sessionRequest.get('user'),
      this.props.sessionRequest.get('sessionLength')
    )
  }

  dismissRequest (e) {
    if (e) e.preventDefault()

    this.props.onDismissRequest(
      this.props.sessionRequest.get('expert'),
      this.props.sessionRequest.get('user')
    )

    this.closeModal(e)
  }

  closeModal (e) {
    if (e) e.preventDefault()

    this.props.onCloseModal(this.props.modalKey)
  }

  renderJustAcceptedMessage () {
    return (
      <p>
        You have accepted this session request from {this.props.userName}.<br/>
        Give user a moment to complete payout steps.
      </p>
    )
  }

  renderBody () {
    if (this.props.currentSessionRef && this.props.currentSession) {
      const status = this.props.currentSession.get('status')
      const sessionLength = this.props.currentSession.get('sessionLength')

      if (status === SESSION_STATUSES.COMPLETED) {
        return (
          <p>
            Your session with {this.props.userName} is ended.<br/>
          </p>
        )
      }
      else if (this.isSessionGoodToGo(status, sessionLength)) {
        return (
          <p>
            Your session with {this.props.userName} is good to go.<br/>
            Go to your session now.
          </p>
        )
      }
      else if (status <= SESSION_STATUSES.REQUESTED_CANCEL) {
        return (
          <p>
            Your session with {this.props.userName} is cancelled.<br/>
          </p>
        )
      }
      else if (this.props.sessionRequest.get('status') === SESSION_REQUEST_STATUSES.ACCEPTED) {
        return this.renderJustAcceptedMessage()
      }
    }
    else if (this.props.sessionRequest.get('status') === SESSION_REQUEST_STATUSES.ACCEPTED) {
      return this.renderJustAcceptedMessage()
    }
    else if (this.props.sessionRequest.get('status') === SESSION_REQUEST_STATUSES.REQUESTED) {
      return (
        <p>
          User {this.props.userName} has just requested an immediate session with you.<br/>
          Press accept to initiate this session now.
        </p>
      )
    }
    else if (this.props.sessionRequest.get('status') === SESSION_REQUEST_STATUSES.TIMEDOUT) {
      return (
        <p>
          You have just missed an immediate session request from {this.props.userName}.
        </p>
      )
    }
  }

  renderActions () {
    if (this.props.currentSessionRef && this.props.currentSession) {
      const status = this.props.currentSession.get('status')
      const sessionLength = this.props.currentSession.get('sessionLength')

      if (status === SESSION_STATUSES.COMPLETED) {
        return (
          <div className='actions right'>
            <div className='cancel button default' onClick={this.closeModal}>Close</div>
          </div>
        )
      }
      else if (this.isSessionGoodToGo(status, sessionLength)) {
        return (
          <div className='actions right'>
            <GoToSessionButton sessionId={this.props.currentSessionRef}/>
            <div className='cancel button default' onClick={this.closeModal}>Close</div>
          </div>
        )
      }
      else if (status <= SESSION_STATUSES.REQUESTED_CANCEL) {
        return (
          <div className='actions right'>
            <div className='cancel button default' onClick={this.closeModal}>Close</div>
          </div>
        )
      }
    }
    else if (this.props.sessionRequest.get('status') === SESSION_REQUEST_STATUSES.REQUESTED) {
      return (
        <div className='actions right'>
          <div className='accept button success' onClick={this.acceptRequest}>Accept</div>
          <div className='cancel button default' onClick={this.dismissRequest}>Dismiss</div>
        </div>
      )
    }
    else if (this.props.sessionRequest.get('status') === SESSION_REQUEST_STATUSES.TIMEDOUT) {
      return (
        <div className='actions right'>
          <div className='cancel button default' onClick={this.closeModal}>Close</div>
        </div>
      )
    }
  }

  renderModalContent () {
    if (this.props.sessionRequest && this.props.userName) {
      return (
        <div>
          <div className='modal-header'>
            <h4>Session Request from {this.props.userName}</h4>
          </div>
          <div className='modal-body'>
            {this.renderBody()}
          </div>
          <div className='modal-footer'>
            {this.renderActions()}
          </div>
        </div>
      )
    }
  }

  render () {
    return (
      <ModalView isActive={true} onClose={this.onClose}>
        {this.renderModalContent()}
      </ModalView>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  // TODO: remove this after turning users object in to full map at reducer.
  const user = state.getIn(['users', ownProps.sessionRequest.get('user')])
  let userName

  if (user) {
    userName = Map.isMap(user) ? user.get('name') : user.name
  }

  const sessionRequest = state.getIn(['sessions', '_requests', ownProps.sessionRequest.get('user')])
  const currentSessionRef = sessionRequest ? sessionRequest.get('sessionId') : null
  let currentSession

  if (currentSessionRef) {
    currentSession = state.getIn(['sessions', 'experts', currentSessionRef])
  }

  return {
    userName: userName,
    sessionRequest,
    currentSessionRef,
    currentSession
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAcceptRequest: acceptSessionRequest,
    onDismissRequest: dismissSessionRequest,
    onCloseModal: (modalKey) => dispatch(closeModal(modalKey))
  }
}

const SessionRequestModalContainer = connect(
  mapStateToProps, mapDispatchToProps
)(SessionRequestModal)

export default SessionRequestModalContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/session_request_modal.js
 **/